<script setup>

import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { debounce } from "lodash";

import ProductCard from './ProductCard.vue'
import ProductGrids from './ProductGrids.vue'

const props = defineProps({
  search_term: String,
  plant_origins: Array,
  plant_foliages: Array,
  plant_flowering_seasons: Array,
  plant_types: Array,
  isBrochureMode: {
    type: [Boolean, String],
    default: false
  },
  showPrices: {
    type: [Boolean, String],
    default: true
  },
  showBotanical: {
    type: [Boolean, String],
    default: false
  },
  defaultImage: {
    type: String,
    default: '/images/default.jpg'
  }
})

// Convert string props to boolean
const isBrochureMode = computed(() => {
  return props.isBrochureMode === true || props.isBrochureMode === 'true'
})

const showPrices = computed(() => {
  return props.showPrices === true || props.showPrices === 'true'
})

const selected_filters = ref({
  s: props.search_term ? [props.search_term] : [],
  origins: [],
  foliages: [],
  flowering_seasons: [],
  plant_types: [],
});

const products = ref([]);

const emitDebugProducts = () => {
  window.dispatchEvent(new CustomEvent('product-list:debug', {
    detail: {
      products: products.value,
      filters: selected_filters.value,
    }
  }))
}

const getProducts = debounce(async () => {
  try {
    const params = new URLSearchParams();
    Object.keys(selected_filters.value).forEach((key) => {
      if (selected_filters.value[key].length) {
        params.set(key, selected_filters.value[key].join(","));
      }
    });

    const { data } = await axios.get(`/api/products?${params.toString()}`);

    products.value = data['data'];
    emitDebugProducts();
  } catch (error) {
    console.error('Error fetching products:', error);
  }
},500);

const updateFilters = (category, value) => {
  const index = selected_filters.value[category].indexOf(value);

  if (index > -1) {
    selected_filters.value[category].splice(index, 1);
  } else {
    selected_filters.value[category].push(value);
  }

  getProducts();
};

onMounted(() => {
  getProducts();
});
</script>


<template>
  <div class="shop shop-listing-page">

      <div class="shop-filter-triggers">
          <a class="shop-filter-trigger" href="#" data-ec-toggle="offcanvas" data-ec-target="#shop-sort">
              <svg focusable="false" role="img">
                  <use xlink:href="/build/assets/icons.svg#sort" href="/build/assets/icons.svg#sort"/>
              </svg>
              Sort By
          </a>
          <a class="shop-filter-trigger" href="#" data-ec-toggle="offcanvas" data-ec-target="#shop-filter">
              <svg focusable="false" role="img">
                  <use xlink:href="/build/assets/icons.svg#refine" href="/build/assets/icons.svg#refine"/>
              </svg>
              Refine
          </a>
      </div>

      <div class="container">
          <div class="row justify-content-between shop-main-row">
              <div class="col-3 shop-sidebar">
                  <product-filters
                    @update="updateFilters"
                    :selected_filters="selected_filters"
                    :plant_origins="plant_origins"
                    :plant_foliages="plant_foliages"
                    :plant_flowering_seasons="plant_flowering_seasons"
                    :plant_types="plant_types"
                  />
              </div>
              <div class="col-8 shop-main">
                  <ProductGrids
                      :products="products"
                      :is-brochure-mode="isBrochureMode"
                      :show-prices="showPrices"
                      :show-botanical="showBotanical"
                      :default-image="props.defaultImage"
                  />
              </div>
          </div>
      </div>
  </div>
</template>
